module.exports = __webpack_public_path__ + "img/mobile_avatar.eb0082b8.jpg";